var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4555_4170",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4555_4170)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.73396 13.5445L12.3365 7.94197L11.4583 7.06378L6.73396 11.7881L4.35896 9.41313L3.48077 10.2913L6.73396 13.5445ZM7.91804 17.9163C6.8231 17.9163 5.7939 17.7085 4.83046 17.293C3.867 16.8774 3.02893 16.3135 2.31625 15.6011C1.60356 14.8887 1.03934 14.051 0.623604 13.088C0.207868 12.125 0 11.096 0 10.0011C0 8.90611 0.207778 7.87691 0.623334 6.91347C1.03889 5.95001 1.60285 5.11194 2.31521 4.39926C3.02758 3.68656 3.86528 3.12235 4.82831 2.70661C5.79133 2.29088 6.82031 2.08301 7.91525 2.08301C9.0102 2.08301 10.0394 2.29079 11.0028 2.70634C11.9663 3.1219 12.8044 3.68586 13.517 4.39822C14.2297 5.11059 14.794 5.94829 15.2097 6.91132C15.6254 7.87434 15.8333 8.90332 15.8333 9.99826C15.8333 11.0932 15.6255 12.1224 15.21 13.0858C14.7944 14.0493 14.2304 14.8874 13.5181 15.6001C12.8057 16.3127 11.968 16.877 11.005 17.2927C10.042 17.7084 9.01299 17.9163 7.91804 17.9163Z",
    fill: "#9B9B9B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check_circle.e951017767d58db47cb692a7c72eb265.svg";
export { ForwardRef as ReactComponent };